import { COLORS } from "../../utils/colors";

export const UvSliderStlyes = {
  height: 8,
  "& .MuiSlider-rail": {
    border: "none",
    backgroundColor: COLORS.gray,
  },
  "& .MuiSlider-track": {
    border: "none",
    backgroundColor: "transparent",
  },
  "& .MuiSlider-mark": {
    border: "none",
    backgroundColor: "transparent",
  },
  "& .MuiSlider-thumb": {
    height: 14,
    width: 14,
    backgroundColor: COLORS.thumbGreenColor,
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&::before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: COLORS.thumbGreenColor,
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&::before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
};
